import { jsx as i } from "react/jsx-runtime";
import { useEffect as m } from "react";
import { attributes as n } from "../utils/attributes.js";
import '../../assets/Backdrop.css';function u({
  open: t,
  onClose: e,
  style: r,
  className: a = "",
  removeScroll: o = !1
}) {
  const c = n({ "aria-expanded": t });
  return m(() => {
    o && document.documentElement.classList.toggle("document-noOverflow");
  }, [t, o]), /* @__PURE__ */ i(
    "div",
    {
      ...c,
      className: "backdrop " + a,
      onClick: e,
      style: r
    }
  );
}
export {
  u as Backdrop
};
//# sourceMappingURL=Backdrop.js.map
